import { render, staticRenderFns } from "./LeaderBoardForm.vue?vue&type=template&id=bee43d28&"
import script from "./LeaderBoardForm.vue?vue&type=script&lang=js&"
export * from "./LeaderBoardForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports